import React, { useEffect, useState } from "react";

import ChartLegend from "../../../common/ChartLegend";
import DoughnutChart from "../../../common/DoughnutChart";

const RevenuesChart = ({ data }) => {
  const [chartData, setChartData] = useState([]);

  useEffect(() => {
    let { revenues } = data;

    if (revenues) {
      let labels = revenues.map((l) => l.name);
      let values = revenues.map((v) => v.balance);
      let colors = ["#075DA9", "#65CAFF", "#EF9C0E", "#48C29D", "#FB9A99"];

      let _chartData = [];

      revenues.forEach((r, i) => {
        let _tmpObj = {
          label: labels[i],
          color: colors[i],
          value: values[i],
        };

        _chartData.push(_tmpObj);
      });

      setChartData(_chartData);
    }
  }, [data]);

  return (
    <div className="finance-wrapper-box">
      <div className="chart-card">
        <div className="chart">
          <DoughnutChart data={chartData} />
        </div>
        <div className="chart-legend">
          <ChartLegend data={chartData} symbol={" "} />
        </div>
      </div>
    </div>
  );
};

export default RevenuesChart;
